import type { StorageWrapper } from '@otto-ec/global-resources/storage';
import { log } from '@shared/log.browser.ts';

let globalStorage: StorageWrapper | undefined = undefined;

const getGlobalStorage = async () => {
    if (globalStorage) return globalStorage;

    globalStorage = (await import('@otto-ec/global-resources/storage')).storage(window.sessionStorage);

    return globalStorage;
};

const ID_KEY = 'reptile_dundee_cacheId';

/**
 *
 *
 *
 *
 *
 */
const date = new Date();

export const CACHE_DURATION = 5;

export async function refreshCacheKey(minutes?: number, id = ID_KEY) {
    const hash = generateHash(location.href.replace(location.hash, ''));
    await safeSetItem(id, (minutes ?? getMinutes()) + '_' + hash);
}

export async function deleteContent(contentKey: string) {
    if ((await safeGetItem(contentKey)) != null) {
        const storage = await getGlobalStorage();
        storage.removeItem(contentKey);
    }
}

export async function cacheIsValid(id = ID_KEY) {
    const keys = await safeGetItem(id);
    let result;

    if (keys != null) {
        result = keys.split('_');
        const durationCheck = getMinutes() - parseInt(result[0], 10) <= CACHE_DURATION;
        const htmlHashCheck = parseInt(result[1], 10) === generateHash(location.href.replace(location.hash, ''));
        return durationCheck && htmlHashCheck;
    }

    return false;
}

export async function safeSetItem(key: string, val: string) {
    try {
        const storage = await getGlobalStorage();
        storage.setItem(key, val);
    } catch (err) {
        log.error(err);
    }
}

export async function safeGetItem(key: string) {
    try {
        const storage = await getGlobalStorage();
        return storage.getItem(key);
    } catch (err) {
        log.debug(err);
    }
}

export function generateHash(value: string): number {
    let hash = 0;
    let i;
    let chr;
    let len;

    if (value.length === 0) {
        return hash;
    }

    for (i = 0, len = value.length; i < len; i++) {
        chr = value.charCodeAt(i);
        hash = (hash << 5) - hash + chr;
        hash |= 0; /*                       */
    }

    return hash;
}

function getMinutes() {
    return Math.floor(date.getTime() / 1000 / 60);
}
